var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemoteIcon = function SvgRemoteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.027,
    height: 34.94,
    viewBox: "0 0 35.027 34.94",
    fill: "#FFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Office_738331",
    transform: "translate(96 -522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M44.285,44.94H10.655A.672.672,0,0,1,10,44.285v-1.31a.672.672,0,0,1,.655-.655h1.31V10.655A.672.672,0,0,1,12.62,10H26.858a.672.672,0,0,1,.655.655v9.7H42.407a.672.672,0,0,1,.655.655V42.363h1.31a.672.672,0,0,1,.655.655v1.31A.841.841,0,0,1,44.285,44.94ZM24.893,42.363V34.589H20.351v7.774h4.542Zm-10.351,0h4.542V34.589H14.542Zm3.887-29.786H14.542v3.887h3.887Zm0,6.464H14.542v3.887h3.887Zm0,6.508H14.542v3.887h3.887Zm6.464-12.971H21.006v3.887h3.887Zm0,6.464H21.006v3.887h3.887Zm0,6.508H21.006v3.887h3.887Zm1.267,6.464H13.232v1.31H26.16Zm7.774-9.084H30.047v3.887h3.887Zm0,6.464H30.047v3.887h3.887Zm0,6.508H30.047v3.887h3.887ZM40.4,22.928H36.511v3.887H40.4Zm0,6.464H36.511v3.887H40.4Zm0,6.508H36.511v3.887H40.4Z",
    transform: "translate(-106 512)",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remote-icon.b5c9741b.svg";
export { ForwardRef as ReactComponent };